// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__24waw","colCheckbox":"styles_colCheckbox__YORd1"};